<template>
  <div class="message-detail-container">
    <div class="head-box">
      <div class="img-box">
        <img v-if="fromHeadPicId" v-lazy="fromHeadPicId" alt="" class="img" />
        <img v-else src="/static/img/logo.png" alt="" class="img" />
      </div>
    </div>

    <div class="right-con">
      <p class="name-box"><span class="name">{{fromName}}</span><span class="official" v-if="fromMemberId == 0">官方</span></p>
      <ul class="detail-list" v-for="(item, index) in list" :key="index">
        <li class="detail-item" @click="jump(item)">
          <div class="message">
            <p class="message-detail">{{item.message}}</p>
            <p class="time"><span>{{item.createTime | formatTime}}</span><a v-if="item.type !== 7" href="javascript:;" class="link">查看详情&nbsp;></a> </p>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import Storage from '@/utils/Storage'
export default {
  name: 'MessageDetail',
  data () {
    return {
      list: [],
      unreadCount: 0,
      fromMemberId: this.$route.params.id,
      fromName: '',
      fromHeadPicId: 0
    }
  },
  computed: {
    ...mapState({
      userData: 'userData'
    }),
    ...mapGetters({
      userId: 'userId'
    })
  },
  methods: {
    jump (item) {
      if (item.type === 7) return
      let path = '/account.html'

      switch (item.type) {
        case 1:
          path = '/baseInfo.html'
          break
        case 3:
          if (this.userData.firstBaseAuth) {
            path = 'displayInfo.html'
          } else {
            path = '/baseInfo.html'
          }
          break
        case 4:
          path = '/upload-cert.html'
          break
        case 5:
          path = '/upload-education.html'
          break
        case 6:
          path = '/upload-career.html'
          break
        case 8:
          path = '/account.html'
      }

      this.$router.push({
        path
      })
    }
  },
  mounted () {
    this.$root.openLoading()
    this.$http('/api/member/message/list', {
      fromMemberId: this.fromMemberId
    }, 'get').then(res => {
      this.$root.closeLoading()
      if (res.code === '0000') {
        this.list = res.data.data
        if (this.list.length > 0) {
          this.fromName = this.list[0].name || 'Hello部落'
          this.fromHeadPicId = this.list[0].headPicUrl
        }
      } else {
        this.$toast(res.msg)
      }
    }, err => {
      this.$root.closeLoading()
      this.$toast(err)
    })
  }
}
</script>

<style lang="scss">
  @import "@/assets/scss/constant.scss";
  .message-detail-container {
    display: flex;
    padding: 40px;
    .head-box {
      flex: 0 0 80px;
    }
    .right-con {
      margin-left: 20px;
      flex: 1 1 auto;
      .name {
        display: inline-block;
        vertical-align: middle;
        font-size: 28px;
        line-height: 40px;
        font-weight: bold;
      }
      .official {
        display: inline-block;
        vertical-align: middle;
        margin-left: 20px;
        padding: 0 10px;
        color: #fff;
        font-size: 20px;
        line-height: 28px;
        border-radius: 4px;
        background: $mainColor;
      }
    }
    .detail-item {
      position: relative;
      margin-bottom: 50px;
    }
    .message {
      margin-top: 10px;
      padding: 20px;
      font-size: 24px;
      line-height: 40px;
      border-radius: 4px;
      background: #F6F8FF;
      &:before {
        content: '';
        position: absolute;
        top: 12px;
        left: -6px;
        border-top: 8px solid transparent;
        border-bottom: 8px solid transparent;
        border-right: 6px solid #F6F8FF;
      }
    }
    .message-detail {
      margin-bottom:  10px;
      padding-bottom: 10px;
      border-bottom: 1px solid #c2c2c2;
    }
    .time {
      margin-top: 10px;
      color: #9b9b9b;
      font-size: 24px;
      line-height: 34px;
      display: flex;
      justify-content: space-between;
    }
    .link {
      color: $mainColor;
      font-size: 24px;
      line-height: 34px;
    }
  }
</style>
